import To from 'await-to-js'
import qs from 'qs'
import Callback from '@/services/Callback'
import { wizStandardInstance, diyInstance } from './instance'

export default class DataReceptionService {
  static async getList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataStagingArea/list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getClassList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataStagingArea/get_class/${payload.id}`)
    )
    return Callback(err, res)
  }
  static async getDataList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataStagingArea/get_data_list/${payload.stagingAreaId}/${payload.classId}`
      )
    )
    return Callback(err, res)
  }
  static async getNewDataList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataStagingArea/get_data_pager/${payload.stagingAreaId}/${payload.classId}/?page=${payload.pageno}&pagesize=${payload.pagesize}`
      )
    )
    return Callback(err, res)
  }
  static async updateData(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/std/StdDataStagingArea/update_data', payload)
    )
    return Callback(err, res)
  }
  static async updateStatusFail(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch(`/api/std/StdDataStagingArea/update_status_fail/${payload.id}`)
    )
    return Callback(err, res)
  }
  static async submit(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(`/api/std/StdDataStagingArea/submit/${payload.id}`)
    )
    return Callback(err, res)
  }
  static async deleteRow(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdDataStagingArea/delete', {
        data: payload.ids,
      })
    )
    return Callback(err, res)
  }
  // 获取需要审批的数据表
  static async getApprovalTable(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataStagingArea/data_table_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 新增数据审批
  static async addApproval(payload) {
    const [err, res] = await To(wizStandardInstance.put('/api/std/StdDataStagingArea', payload))
    return Callback(err, res)
  }
  // 修改审批人
  static async editApproval(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/std/StdDataStagingArea/process_user', payload)
    )
    return Callback(err, res)
  }
  // 数据审批
  static async approval(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataStagingArea/approval', payload)
    )
    return Callback(err, res)
  }
  // 获取组织机构
  static async getSystemGroup(payload) {
    const [err, res] = await To(diyInstance.post('/api/SysDept/GetSysDeptStep', payload))
    return Callback(err, res)
  }
  // 获取员工账号
  static async getApprovalUser(payload) {
    const [err, res] = await To(
      diyInstance.post('/api/SysUser/GetSysUser', qs.stringify(payload), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
    )
    return Callback(err, res)
  }
}
